<template>
    <textarea
        v-bind="$attrs"
        class="form-textarea"
        ref="textarea"
        v-on="listeners"
    />
</template>

<script>
    import insertAtCaret from 'insert-text-at-cursor';

    export default {
        computed: {
            listeners() {
                return {
                    ...this.$listeners,
                    input: e => this.$emit('input', e.target.value),
                };
            },
        },

        methods: {
            async insertAtCaret(text) {
                await this.$nextTick();

                insertAtCaret(this.$refs.textarea, text);
            },

            focus() {
                this.$refs.textarea.focus();
            },
        },
    };
</script>
